import { useQuery } from '@tanstack/react-query'
import { getProductChangeEvents, type ChangeEventsParams, type ChangeEvent } from '@/lib/api/performance'

const STALE = 30 * 60_000

export function useChangeEvents(productId: string | undefined, params: ChangeEventsParams) {
  return useQuery<ChangeEvent[]>({
    queryKey: ['change-events', productId, params.from, params.to, params.channelId, (params.types ?? []).join(',')],
    queryFn: () => getProductChangeEvents(productId as string, params),
    enabled: !!productId,
    staleTime: STALE,
  })
}
